module.exports = __webpack_public_path__ + "static/media/horizons-solution.6746cd78.svg";